import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';




export function getCursoAprendizajeListSuccess(cursoaprendizaje) {
  return {type: types.LOAD_CURSOAPRENDIZAJE_LIST_SUCCESS, cursoaprendizaje};
}



export function getCursoAprendizajeList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoAprendizajeApi.getCursoAprendizajeList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(cursoaprendizaje => {                  
                  dispatch(getCursoAprendizajeListSuccess(cursoaprendizaje));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getCursoAprendizajeSuccess(catalogo) {
  return {type: types.LOAD_CURSOAPRENDIZAJE_SUCCESS, catalogo};
}

export function getCursoAprendizaje(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().CursoAprendizajeApi.getCursoAprendizaje(id, token).then(cursoaprendizaje => {   
        dispatch(getCursoAprendizajeSuccess(cursoaprendizaje));
        return cursoaprendizaje;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(cursoaprendizaje) {
  return {type: types.SAVE_CURSOAPRENDIZAJE_SUCCESS, cursoaprendizaje};
}


export function save(cursoaprendizaje, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().CursoAprendizajeApi.save(cursoaprendizaje, token).then(cursoaprendizajeGuardado => {   
    dispatch(saveSuccess(cursoaprendizajeGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getCursoAprendizajeComboSuccess(datos) {
  return {type: types.GET_CURSOAPRENDIZAJES_COMBO_SUCCESS, datos};
}

export function getCursoAprendizajeCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().CursoAprendizajeApi.getCursoAprendizajeCombo(token).then(datos => {   
        
      dispatch(getCursoAprendizajeComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(cursoaprendizaje) {
  return {type: types.BORRAR_CURSOAPRENDIZAJE_SUCCESS, cursoaprendizaje};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoAprendizajeApi.borrar(id, token ).then(cursoaprendizaje => {
               
                  dispatch(borrarSuccess(cursoaprendizaje));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(cursoaprendizaje) {
  return {type: types.ACTIVAR_CURSOAPRENDIZAJE_SUCCESS, cursoaprendizaje};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().CursoAprendizajeApi.activar(id, token).then(cursoaprendizaje => {
               
                  dispatch(activarSuccess(cursoaprendizaje));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_CURSOAPRENDIZAJE, filtro};
}



